import React from 'react'
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card'
import { ArrowRight, Guide } from '../Icon'

function CoinInfo({ description, guide, whitepaper }) {
  if (!description) {
    return null
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>About</CardTitle>
      </CardHeader>
      <CardContent>
        <div
          className="text-walme-text-dim leading-relaxed mb-6"
          dangerouslySetInnerHTML={{ __html: description }}
        />

        {(guide || whitepaper) && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {guide && (
              <a href={guide} target="_blank" rel="noopener noreferrer">
                <Card className="hover:border-walme-primary transition-all cursor-pointer">
                  <CardContent className="p-4">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <Guide className="w-5 h-5 text-walme-primary" />
                        <span className="font-semibold text-walme-text">Guide</span>
                      </div>
                      <ArrowRight className="w-4 h-4 text-walme-text-dim" />
                    </div>
                  </CardContent>
                </Card>
              </a>
            )}
            {whitepaper && (
              <a href={whitepaper} target="_blank" rel="noopener noreferrer">
                <Card className="hover:border-walme-primary transition-all cursor-pointer">
                  <CardContent className="p-4">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-3">
                        <Guide className="w-5 h-5 text-walme-primary" />
                        <span className="font-semibold text-walme-text">Whitepaper</span>
                      </div>
                      <ArrowRight className="w-4 h-4 text-walme-text-dim" />
                    </div>
                  </CardContent>
                </Card>
              </a>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  )
}

export default CoinInfo
